var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import ReactDropzone from 'react-dropzone';
import styles from './dropzone.module.scss';
export const Dropzone = (_a) => {
    var { className, children, status } = _a, dropzoneProps = __rest(_a, ["className", "children", "status"]);
    const rootClass = classNames({
        [styles.dropzone]: true,
        [styles.dropzoneActive]: status === 'pending',
        [styles.dropzoneFulfilled]: status === 'fulfilled',
        [styles.dropzoneRejected]: status === 'rejected',
    }, className);
    return (_jsx(ReactDropzone, Object.assign({ className: rootClass, activeClassName: styles.dropzoneActive, rejectClassName: styles.dropzoneRejected }, dropzoneProps, { children: children })));
};
